<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad"
                                 :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row">
            <div class="left">
                <div class='swb-btn swb-btn-small' v-if="checkActionPerm('create')" @click="goToNewPage()">新增请购单
                </div>
                <div class='swb-btn swb-btn-small' v-if="checkActionPerm('saveBatch') && bizUnitLevel == 1"
                     @click="goToNewPageForBatch()">
                    <span>批量创建</span>
                </div>
            </div>
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="saveOrderList()">生成订单</div>
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出</a>
            </div>
        </div>
        <div name="tab-container" class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="item in requireVoucherStateList" :class="{'current': item.name == checkStateValue}"
                        class="head-item" @click="tabChange(item.name)">
                        <span>{{ item.text }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table"
                          :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect"
                          :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed"
                          :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                          :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"
                          :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
import { showGrpDownloadDlg } from '../ctrl/dialog'
// 审核组件
import { showComAuditorSelectDlg } from '../merchant/showSelectDlg'
import { openApplyDescDlg } from '../bizUnion/selectDlg'
import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
import { showBizAuditDlg } from '../merchant/showSelectDlg'
import { deviceRequireVoucherUpdateDlg, requireGoodsItemStatisDlg } from './dialog'
import {
    getMerchtAuditBpConfInfo,
    openOaAuditRecDlg,
    openOaAuditBpNodeDlg,
    openDingdingAuditViewDlg,
    openAuditTypeDlg, openFeiShuAuditViewDlg
} from '../oaAudit/selectDlg'
import { checkUserActionPerm } from '../index'
import { showRouteLayer } from '../ctrl/RouteLayer'

//导入主件
import SwbDeviceRequireVocherSave from './DeviceRequireVocherSave';

Routes.add(SwbDeviceRequireVocherSave);

import swbRequireGoodsItemList from './RequireGoodsItemList.vue'

Vue.regist(swbRequireGoodsItemList);

import swbDeviceRequireAuditRecList from './DeviceRequireAuditRecList.vue'

Vue.regist(swbDeviceRequireAuditRecList);

import swbRequireGoodsItemUpdate from './RequireGoodsItemUpdate.vue'

Vue.regist(swbRequireGoodsItemUpdate);

import SwbRequireAudit from './RequireAudit';

Vue.regist(SwbRequireAudit);

import SwbAppointAuditor from './AppointAuditor';

Vue.regist(SwbAppointAuditor);

import SwbDeviceRequireVocherSearch from './DeviceRequireVoucherSearch';

Vue.regist(SwbDeviceRequireVocherSearch);

import SwbDeviceRequireActRecList from './DeviceRequireActRecList';

Vue.regist(SwbDeviceRequireActRecList);
import SwbGoodsOrderList from '../order/GoodsOrderList';

Vue.regist(SwbGoodsOrderList);

import SwbContractGoodsOrderList from '../order/ContractGoodsOrderList';

Vue.regist(SwbContractGoodsOrderList);

import SwbDeviceRequireVoucherFile from './DeviceRequireVoucherFile';

Vue.regist(SwbDeviceRequireVoucherFile);

import SwbResultColConf from '../query/ResultColConf.vue';
import SwbResultTable from '../query/ResultTable.vue';

Vue.regist(SwbResultColConf);
Vue.regist(SwbResultTable);
//导入Api
import userApi from '../../api/user'
import devcReqrApi from '../../api/devcReqr'
import retailerApi from '../../api/retailer'
import merchantComnApi from '../../api/merchtComn'
import oaAuditApi from '../../api/oaAudit'
import shopDevcApi from '../../api/shopDevc'
import { getMerchantBizParam } from '../asset/assetMain';
//主件
export default {
    name: 'swb-device-require-voucher-manager',
    path: '/device/require/voucher/list',
    pathOld: '/adopted/device/voucher/list',
    avlActions: 'create|view|modify|delete|apply|assign_audit|audit|view_audit_rec|view_rec',
    avlActionNames: '新增、查看、修改、删除、申请、审核记录、审核、',
    avlScopes: 'retailer',
    desc: '设备请求单列表',
    data: function () {
        return {
            confKey: 'swb-device-require-voucher-manager',
            queryOnLoad: true,
            //
            theTableHeight: 300,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）

            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 220,//操作列宽度（默认：100）
            //
            btnColFixed: true, //操作列是否固定
            //
            pageSize: getDefaultPageSizes().first(),
            pageNumber: 1,
            isAuditBpConfAvailable: false,
            needAssignAuditors: false,
            dingDingAuditFlag: false,
            feiShuAuditFlag: false,
            requireVoucherState: {},
            requireVoucherStateList: [],
            requireVoucherList: [],
            comId: null,
            bizUnitLevel: null,
            postId: null,
            pickerOptions0: null,
            pickerOptions1: null,
            beginTime: null,
            endTime: null,
            requireComName: null,
            applicantName: null,
            checkStateValue: 'All',
            deviceRequireVoucher: {
                itemList: [],
            },
            userInfo: null,
            scopeEntity: {},
            retailerId: null,
            searchShow: false,
            //排序、搜索
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            totalCount: 0,
            exportFilter: {},
            //
            no: null,
            innerNo: null,
            headComFlag: false,
            shopFlag: false,
            goodsPurch: null,
            requireBackConfirm: false,
            needFutherAudit: false
        }
    },

    created: function () {
        let self = this;
        // 1、检查当前商户是否开启外部审批：获取已就绪的业务审批流、优先级为 seqNo。
        getMerchtAuditBpConfInfo('retailer.assets.purch', false, function (auditBpConfInfo) {
            if(!Utils.isNoB(auditBpConfInfo)) {
                self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2); // 钉钉
                self.feiShuAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 3); // 飞书
                if(!self.dingDingAuditFlag && !self.feiShuAuditFlag) {
                    // 2、如果自建的业务审批流程、检查看商户OA对接点是否就绪
                    self.isMerchtAuditBpConfAvailable();
                }
            } else {
                // 走系统内部审批
            }
        });
        getMerchantBizParam('outer.indepent.purch.req.voucher.need.futher.audit', function (result) {
            self.needFutherAudit = Utils.isTrue(result);
        }, 0);
        //
        let routeQuery = this.$getRouteQuery();
        this.no = routeQuery.no || null;
        this.innerNo = routeQuery.innerNo || null;
        this.checkStateValue = routeQuery.checkStateValue || 'All';
        this.goodsPurch = getEnumInfoWith('purchType', 'name', 'Goods').value;
        this.getCurrentUserInfo();
        this.checkAuditByHeadCom();
        this.checkRequireBackConfirm();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;

        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.simple-row,[name="query-sort-block"], [name="tab-container"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        // 获取回溯确认业务参数
        checkRequireBackConfirm: function () {
            let self = this;
            let postData = {
                code: 'purch.accecpt.require.back.confirm'
            };
            merchantComnApi.getMerchantBizParamValue(postData, function (result) {
                if(result.type == 'info') {
                    self.requireBackConfirm = Utils.isTrue(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.purch'}, function (result) {
                if(result.type == 'info') {
                    self.isAuditBpConfAvailable = Utils.isTrue(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        checkAuditByHeadCom: function () {
            let self = this;
            let postData = {
                code: 'asset.purch.audit.by.head.com'
            };
            merchantComnApi.getMerchantBizParamValue(postData, function (result) {
                if(result.type == 'info') {
                    self.headComFlag = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },

        onConfigReady() {
            let no = this.no;
            if(no != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: no};
                let fieldInfo = {};
                fieldInfo['no'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            if(!Utils.isNoB(this.innerNo)) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: this.innerNo};
                let fieldInfo = {};
                fieldInfo['innerNo'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'no': function (row, colName, colValue, rowIndex, btnName) {
                    return '<a href="#" class="table-cell-link">' + row.no + '</a>';
                },
                'requireBizUnitNameX': function (row, colName, colValue, rowIndex, btnName) {
                    if(row.requireBizUnitId != row.requireComId) {
                        return '<span>' + (row.requireBizUnitName || '') + '/' + (row.requireComName || '') + '</span>';
                    } else {
                        return '<span>' + (row.requireBizUnitName || '') + '</span>';
                    }

                },
                'auditStateX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.applyState == 1) {
                        return '<span class="font-gold">未审核</span>';
                    } else if(row.applyState == 2 && row.auditState === 1) {
                        return '<span class="font-green">审核已通过</span>';
                    } else if(row.auditState === -1) {
                        return '<span class="font-red">审核未通过</span>';
                    }
                },
                'requireComNameX': function (row, colName, colValue, rowIndex, btnName) {
                    return '<span>' + (row.appliedBizUnitName || '') + '/' + (row.appliedComName || '') + '</span>';
                },
                'centBuyMode': function (row, colName, colValue, rowIndex, btnName) {
                    let domHtml = '';
                    if(row.centBuyMode) {
                        domHtml = domHtml + '<span>集采</span>'
                    } else {
                        domHtml = domHtml + '<span>自采</span>'
                    }
                    return domHtml;
                },
                'purchType': function (row, colName, colValue, rowIndex, btnName) {
                    return self.getPurchType(row.purchType);
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    let btnList = [];
                    // && row.requireComId == self.comId 谁创建谁申请
                    if(self.checkActionPerm('apply', row.creatorPostId) && !row.invalid && (row.applyState == 0 || row.auditState == -1)) {
                        btnList.push({
                            name: 'apply',
                            text: '申请'
                        });
                    }
//                        if(self.checkActionPerm('apply') && self.isAuditBpConfAvailable && row.outerAuditFlag && !row.bpInstStarted && row.applyState == 1 && row.auditState != 1) {
//                            btnList.push({
//                                name: 'openOuterBpStartWin',
//                                text: '申请1'
//                            })
//                        }
                    if(!row.outerAuditFlag && (!Utils.isTrue(self.isAuditBpConfAvailable) || row.multiShopFlag) && !row.invalid && (self.headComFlag && self.scopeEntity.bizUnitLevel == 1 || !self.headComFlag) && (row.auditorStaffId == null || self.scopeEntity.staffId == row.auditorStaffId) && (row.applyState == 1 && row.auditState == 0) && (row.auditorPostId == null || self.postId == row.auditorPostId) && self.checkActionPerm('audit')) {
                        btnList.push({
                            name: 'audit',
                            text: '审核'
                        });
                    }
                    // 谁创建谁修改
                    if((row.applyState == 0 || row.auditState == -1) && !row.invalid && self.checkActionPerm('modify', row.creatorPostId)) {
                        btnList.push({
                            name: 'modify',
                            text: '修改'
                        });
                    }
                    // 作废
                    if((row.applyState == 0 || row.auditState == -1) && !row.invalid && !row.outerAuditFlag && self.checkActionPerm('invalid')) {
                        btnList.push({
                            name: 'invalid',
                            text: '作废'
                        });
                    }
                    // 谁创建谁删除
                    if(((row.applyState == 0 || row.auditState == -1) || row.invalid) && self.checkActionPerm('delete', row.creatorPostId)) {
                        btnList.push({
                            name: 'delete',
                            text: '删除'
                        });
                    }
                    if(self.checkActionPerm('view')) {
                        btnList.push({
                            name: 'view',
                            text: '查看'
                        });
                    }
                    if(self.checkActionPerm('showFile')) {
                        btnList.push({
                            name: 'showFile',
                            text: '查看附件'
                        });
                    }
                    if(self.checkActionPerm('showGoodsOrder') && row.goodsOrderGenFlag && row.plainOrderFlag) {
                        btnList.push({
                            name: 'showGoodsOrder',
                            text: '查看订单'
                        });
                    }
                    if(self.checkActionPerm('contractShowGoodsOrder') && row.goodsOrderGenFlag && row.contractOrderFlag) {
                        btnList.push({
                            name: 'contractShowGoodsOrder',
                            text: '查看合同订单'
                        });
                    }
                    if(row.applyState != 0 || row.auditState == -1) {
                        if(row.outerAuditFlag) {
                            if(self.checkActionPerm('view_outer_audit_rec')) {
                                btnList.push({
                                    name: 'view_outer_audit_rec',
                                    text: '单据审批记录'
                                });
                            }
                        } else {
                            if(self.checkActionPerm('view_audit_rec')) {
                                btnList.push({
                                    name: 'view_audit_rec',
                                    text: '审核记录'
                                });
                            }
                        }
                    }
                    if(self.checkActionPerm('view_rec')) {
                        btnList.push({
                            name: 'view_rec',
                            text: '操作记录'
                        });
                    }

                    if((row.auditState == 0 || row.auditState == -1) && !row.invalid && self.checkActionPerm('confirm_post') && self.requireBackConfirm) {
                        btnList.push({
                            name: 'confirm_post',
                            text: '回溯确认岗'
                        });
                    }
                    if(self.checkActionPerm('saveOrder') && !row.invalid && !row.goodsOrderGenFlag && row.auditState == 1) {
                        btnList.push({
                            name: 'saveOrder',
                            text: '生成订单'
                        });
                    }
                    return btnList;
                }
            }, /* 单元格按钮点击处理函数 */{
                'no': function (row, colName, colValue, rowIndex, btnName) {
                    self.showDialog(row);
                },
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                    if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                        return;
                    }
                    if(btnName == 'view') {
                        self.showDialog(row);
                    } else if(btnName == 'apply') {
                        self.saveDeviceRequireVocher(row, row.creatorPostId);
                    } else if(btnName == 'modify') {
                        self.goToNewPage(row.id, row.multiShopFlag);
                    } else if(btnName == 'delete') {
                        self.deleteRow(row);
                    } else if(btnName == 'invalid') {
                        self.doInvalidVoucher(row);
                    } else if(btnName == 'confirm_post') {
                        self.doSetConfirmPost(row);
                    } else if(btnName == 'audit') {
                        self.showAuditDialog(row, row.auditorPostId);
                    } else if(btnName == 'view_outer_audit_rec') {
                        self.auditRscDlg(row.no, row.innerNo, row.auditSeqNo);
                    } else if(btnName == 'view_audit_rec') {
                        self.showAuditRecDialog(row);
                    } else if(btnName == 'view_rec') {
                        self.showActRecDialog(row.id);
                    } else if(btnName == 'saveOrder') {
                        self.saveOrderById(row.id);
                    } else if(btnName == 'showGoodsOrder') {
                        self.showOrderById(row.id);
                    } else if(btnName == 'contractShowGoodsOrder') {
                        self.contractShowGoodsOrder(row.id);
                    } else if(btnName == 'openOuterBpStartWin') {
                        self.openOuterBpStartWin(row);
                    } else if(btnName == 'showFile') {
                        self.showFile(row.id);
                    }
                }
            });
        },
        auditRscDlg: function (no, innerNo, auditSeqNo) {
            let bizVoucherNo = no;
            if(!Utils.isNoB(innerNo)) {
                bizVoucherNo = innerNo;
            }
            openOaAuditRecDlg('retailer.assets.purch', auditSeqNo, bizVoucherNo);
        },
        openOuterBpStartWin: function (row) {
            let bizVoucherNo = row.no;
            if(!Utils.isNoB(row.innerNo)) {
                bizVoucherNo = row.innerNo;
            }
            // let pageUrl = 'https://qa-oa-bpm.wumart.com/portal/r/w?cmd=com.awspaas.user.apps.assets.swb.redirectCmd&dircmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&user_id=00000194&processInstId=706a1357-1f27-4692-9d08-0a42c8e94de2&sig=d6dbd24ddff9c6f98516e2992fd5de35';
            let params = {};
            params.bizTypeCode = 'retailer.assets.purch';
            params.bizVoucherNo = bizVoucherNo;
            params.auditSeqNo = row.auditSeqNo;
            oaAuditApi.getBpStartPageUrl(params, function (result) {
                if(result.type === 'info') {
                    let pageUrl = result.data;
                    Utils.openWindow(pageUrl);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getPurchType: function (ourchType) {
            return getEnumInfoWith('purchType', 'value', ourchType).text;
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
            }
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        queryHandler: function (data) {
            this.queryModel = data;
            this.pageNumber = 1;
            this.getRequireVoucherList(this.checkStateValue);
        },
        //检查资源具体操作权限
        checkActionPerm: function (action) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action);
        },
        showSearch: function (flag) {
            this.searchShow = flag;
        },
        // 页签切换
        tabChange: function (val) {
            this.pageNumber = 1;
            this.getRequireVoucherList(val);
        },
        // 起始时间变化事件
        beginTimeChange: function (val) {
            if(!Utils.isNoB(this.endTime)) {
                let endTime = this.endTime.format('yyyy-MM-dd');
                if(endTime < val) {
                    MsgBox.warning('起始时间不能大于结束时间');
                    this.beginTime = null;
                }
            }
        },
        // 结束时间变化事件
        endTimeChange: function (val) {
            if(!Utils.isNoB(this.beginTime)) {
                let beginTime = this.beginTime.format('yyyy-MM-dd');
                if(beginTime > val) {
                    MsgBox.warning('结束时间不能小于起始时间');
                    this.endTime = null;
                }
            }
        },
        getCurrentUserInfo: function () {
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type === 'info') {
                    let userInfo = result.data || {};
                    let requireVoucherStateList = getEnumList('requireVoucherState');
                    let Reported = getEnumInfoWith('requireVoucherState', 'name', 'Reported').value;
                    let Applied = getEnumInfoWith('requireVoucherState', 'name', 'Applied').value;

                    let scopeEntity = userInfo.scopeEntity;
                    for(let i = requireVoucherStateList.length - 1; i > 0; i--) {
                        let requireVoucherState = requireVoucherStateList[i];
                        if(scopeEntity.bizUnitOrgLevel == 1 && requireVoucherState.value == Reported) {
                            requireVoucherStateList.splice(i, 1);
                        }
                        if(scopeEntity.shopFlag && requireVoucherState.value == Applied) {  // 门店不要审核中页签，仅保留【上级审核中页签】
                            requireVoucherStateList.splice(i, 1);
                            if(self.checkStateValue == 'Applied') {
                                self.checkStateValue = 'Reported';
                            }
                        }
                    }
                    requireVoucherStateList.push({
                        'value': 5,
                        'text': '待生成订单',
                        'name': 'waitOrder'
                    }, {
                        'value': 6,
                        'text': '已生成订单',
                        'name': 'orderEnd'
                    });
                    self.postId = scopeEntity.postId;
                    self.comId = scopeEntity.getComId(scopeEntity.comLevel);
                    self.bizUnitLevel = scopeEntity.bizUnitLevel;
                    self.requireVoucherStateList = requireVoucherStateList;
                    self.userInfo = userInfo;
                    self.shopFlag = scopeEntity.shopFlag;
                    self.scopeEntity = Utils.merge({}, scopeEntity);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
            //
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getRequireVoucherList(this.checkStateValue);
        },
        getRequireVoucherList: function (value) {
            let self = this;
            if(Utils.isNoB(value)) {
                self.checkStateValue = 'All';
            } else {
                self.checkStateValue = value;
            }
            let dateForm = self.beginTime;
            let dateTo = self.endTime;
            if(null != dateForm && null != dateTo && dateForm > dateTo) {
                MsgBox.warning('结束时间不能大于开始时间');
                return false;
            }
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            filterItems.voucerState = value;
            if(!Utils.isNoB(self.no)) {
                filterItems.no = self.no;
            }
            filterItems.stuffFlag = false;
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            self.exportFilter = Utils.merge({}, filterItems);
            //
            let theLoad = MsgBox.loading();
            devcReqrApi.getDeviceRequireVoucherList(postData, function (result) {
                theLoad.close();
                if(result.type === 'info') {
                    let resultData = result.data;
                    //
                    let pagination = result.data.pagination;
                    self.totalCount = pagination.totalCount;
                    self.renderTable(resultData.rows, pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 作废请购单
        doInvalidVoucher: function (row) {
            let self = this;
            self.$confirm('确定要作废该请购单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let theLoad = MsgBox.loading();
                let postData = {};
                postData.id = row.id;
                devcReqrApi.updateDeviceRequireVoucherInvalid(postData, function (result) {
                    if(result.type === 'info') {
                        self.getRequireVoucherList(self.checkStateValue);
                        MsgBox.success('操作完成！');
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                })
            }).catch(function () {
            });
        },
        //
        deleteRow: function (rowdata) {
            let self = this;
            self.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let theLoad = MsgBox.loading();
                let postData = {};
                postData.id = rowdata.id;
                devcReqrApi.deleteDeviceRequireVoucher(postData, function (result) {
                    if(result.type === 'info') {
                        self.getRequireVoucherList(self.checkStateValue);
                        MsgBox.success('删除成功')
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                })
            }).catch(function () {
            });
        },
        showDialog: function (data) {
            Vue.$showDialog({
                title: '请购单详情',
                width: -200,
                height: -100,
                centerButtons: false,
                showCloseBtn: true,
                cancelText: '关闭',
                okVisible: false,
                template: '<swb-require-goods-item-list :item="id" ref="swb_require_itemList"></swb-require-goods-item-list>',
                data: {
                    id: data.id
                },
            });
        },
        // 设置回溯确认岗
        doSetConfirmPost: function (row) {
            let self = this;
            //
            showComActionPostSelectDlg({
                rescUrl: null,
                action: null,
                useParent: false,
                headComFlag: false,
                useDesc: false,
                initPostId: row.backConfirmPostId == -1 ? null : row.backConfirmPostId,
                assignComId: self.scopeEntity.comId1,
                assignComId2: row.requireBizUnitId
            }, function (resultData) {
                resultData = resultData || {};
                if(resultData.postId == null) {
                    Toast.show('请选择岗位', 3000, 'warning');
                    return false;
                }
                //
                let postData = {
                    id: row.id,
                    backConfirmPostId: resultData.postId,
                    backConfirmPostName: resultData.postName
                };
                let theLoad = MsgBox.loading();
                devcReqrApi.setDeviceRequireVoucherBackConfirmPostInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        MsgBox.success('设置成功');
                        self.getRequireVoucherList(self.checkStateValue);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }, this);
        },
        //
        showAuditRecDialog: function (data) {
            Vue.$showDialog({
                title: '审核记录',
                width: 945,
                height: 600,
                showCloseBtn: true,
                okVisible: false,
                cancelText: '关闭',
                template: '<swb-device-require-audit-rec-list :tableHeight="500" :item="id" ref="swb_device_require_audit_rec_list"></swb-device-require-audit-rec-list>',
                data: {
                    id: data.id
                },
            });
        },
        showActRecDialog: function (id) {
            Vue.$showDialog({
                title: '操作记录',
                width: '90%',
                height: '80%',
                showCloseBtn: true,
                okVisible: false,
                cancelText: '关闭',
                template: '<swb-device-require-act-rec-list :voucherId="id" ></swb-device-require-act-rec-list>',
                data: {
                    id: id
                },
            });
        },
        showAuditDialog: function (data) {
            let self = this;
            let showFinalAudit = true;
            if(Utils.isTrue(self.shopFlag)) {
                if(data.centBuyMode) {
                    showFinalAudit = false;
                } else if(self.headComFlag) {
                    showFinalAudit = false;
                }
            }
            showBizAuditDlg({
                title: '请购单 - 审核',
                showFinalAudit: showFinalAudit,
                showCheckBoxExt: true,
                checkBoxText: '自动生成订单',
                checkBoxVal: Utils.isTrue(data.autoOrderFlag),
                selectNextPost: true,
                nextPostParams: {
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    useParents: true
                }
            }, function (resultData) {
                resultData = resultData || {};
                let nextPostResultData = resultData.nextPostResultData || null;
                let auditorPostId = null;
                let appliedComId = null;
                let appliedComLevel = null;
                let auditorStaffId = null;
                let auditorName = null;
                if(nextPostResultData != null) {
                    auditorPostId = nextPostResultData.postId;
                    appliedComId = nextPostResultData.comId;
                    appliedComLevel = nextPostResultData.comLevel;
                    auditorStaffId = nextPostResultData.auditorStaffId || null;
                    auditorName = nextPostResultData.auditorName || null
                }
                let finalAudit = resultData.finalAudit;
                let postDate = {
                    id: data.id,
                    auditState: resultData.auditState,
                    auditDesc: resultData.auditDesc,
                    finalAudit: finalAudit,
                    auditorPostId: auditorPostId,
                    auditorStaffId: auditorStaffId,
                    auditorName: auditorName,
                    appliedComLevel: appliedComLevel,
                    appliedComId: appliedComId,
                    retailerId: data.retailerId,
                    autoOrderFlag: Utils.isTrue(resultData.checkBoxVal)
                };
                // 终审可以重新修改商品信息
                if(Utils.isTrue(finalAudit) && data.purchType == self.goodsPurch) {
                    deviceRequireVoucherUpdateDlg({
                        id: data.id,
                        auditDesc: resultData.auditDesc,
                        autoOrderFlag: Utils.isTrue(resultData.checkBoxVal)
                    }, function (result, theDlg) {
                        postDate.goodsItemList = result;
                        self.deviceRequireVoucherAudit(postDate, theDlg, finalAudit, resultData.auditState);
                    })
                } else {
                    self.deviceRequireVoucherAudit(postDate, null, finalAudit, resultData.auditState);
                }
            }, this);
        },

        deviceRequireVoucherAudit: function (postDate, theDlg, finalAudit, auditState) {
            let self = this;
            let theLoad = MsgBox.loading();
            devcReqrApi.auditDeviceRequireVoucher(postDate, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    if(!Utils.isNoB(theDlg)) {
                        theDlg.close();
                    }
                    let checkStateValue = 'All';
                    if(Utils.isTrue(finalAudit)) {
                        checkStateValue = 'AuditPass';
                    } else {
                        if(auditState == 1) {
                            checkStateValue = 'Reported';
                        } else {
                            checkStateValue = 'AuditFail';
                        }
                    }
                    MsgBox.success('审核成功');
                    self.getRequireVoucherList(checkStateValue);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        saveDeviceRequireVocher: function (row, initPostId) {
            let self = this;
            if(row.outAuditFlag) {
                // 标记了 已外部审批，直接走内部审批流程
                this.toInnerApplyDeviceRequireVoucher(row, initPostId);
            } else {
                if(self.dingDingAuditFlag && !row.multiShopFlag) {  // 钉钉
                    openAuditTypeDlg(null, function (auditType, theDlg) {
                        theDlg.close();
                        let dingDingFlag = Utils.isTrue(auditType);
                        if(dingDingFlag) {
                            row.dingDingFlag = dingDingFlag;
                            let params = {
                                bizVoucherId: row.id,
                                bizVoucherNo: row.innerNo,
                                bizTypeCode: 'retailer.assets.purch',
                            };
                            openDingdingAuditViewDlg(params, function (resultData) {
                                let departId = resultData.departId;
                                // 返回值：departId（部门ID）
                                self.toAuditBpConf(row, [], null, departId, null);
                            });
                        } else {
                            // 申请内部审批
                            self.toInnerApplyDeviceRequireVoucher(row, initPostId);
                        }
                    });
                } else if(self.feiShuAuditFlag && !row.multiShopFlag) {
                    // 飞书审批 - 暂时注释掉
                    // openAuditTypeDlg('feishu', function (auditType, theDlg) {
                    //     theDlg.close();
                    //     let feiShuFlag = Utils.isTrue(auditType);
                    //     if(feiShuFlag) {
                    //         let params = {
                    //             bizVoucherId: row.id,
                    //             bizVoucherNo: row.innerNo,
                    //             bizTypeCode: 'retailer.assets.purch'
                    //         };
                    //         openFeiShuAuditViewDlg(params, function (resultData) {
                    //             let departId = resultData.departId;
                    //             //
                    //             row.feiShuFlag = feiShuFlag;
                    //             self.toAuditBpConf(row, [], null, departId);
                    //         });
                    //     } else {
                    //         // 申请内部审批
                    //         self.toInnerApplyDeviceRequireVoucher(row, initPostId);
                    //     }
                    // });
                    // 临时逻辑
                    let params = {
                        bizVoucherId: row.id,
                        bizVoucherNo: row.innerNo,
                        bizTypeCode: 'retailer.assets.purch'
                    };
                    openFeiShuAuditViewDlg(params, function (resultData) {
                        let departId = resultData.departId;
                        let decisionBasisVal = resultData.decisionBasisVal;
                        row.bizScenario = resultData.bizScenario || null;
                        //
                        row.feiShuFlag = true;
                        self.toAuditBpConf(row, [], null, departId, decisionBasisVal);
                    });
                } else {
                    if(Utils.isTrue(self.isAuditBpConfAvailable)) { // 走审批流程
                        if(self.needAssignAuditors) {
                            let params = {
                                bizTypeCode: 'retailer.assets.purch',
                                bizVoucherNo: row.innerNo || row.no,
                                auditSeqNo: row.auditSeqNo
                            };
                            openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                                auditorList = auditorList || [];
                                if(auditorList.length <= 0) {
                                    MsgBox.warning('无审批人员信息');
                                    return;
                                }
                                //
                                self.toAuditBpConf(row, auditorList, theDlg);
                            });
                        } else {
                            self.toAuditBpConf(row, [], null);
                        }
                    } else {
                        // 申请内部审批
                        self.toInnerApplyDeviceRequireVoucher(row, initPostId);
                    }
                }
            }
        },
        // 内部审批
        toInnerApplyDeviceRequireVoucher: function (row, initPostId) {
            let self = this;
            if(row.outAuditFlag && self.needFutherAudit == false) {
                self.$confirm('请购单将生成给供方的订单,确定要申请吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: row.id,
                        applyDesc: '外部已审批'
                    };
                    let theLoad = MsgBox.loading();
                    devcReqrApi.applyDeviceRequireVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            self.getRequireVoucherList(self.scopeEntity.shopFlag ? 'Reported' : 'Applied');
                        } else {
                            MsgBox.failure(result.message);
                        }
                        theLoad.hide();
                    });
                }).catch(function () {
                });
            } else {
                // 获取最近一次审核人信息
                let params = {
                    bizUnitId: row.requireBizUnitId,
                    voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Receiving').value
                };
                let theLoad = MsgBox.loading();
                shopDevcApi.getLastAuditInfo(params, function (resultX) {
                    theLoad.hide();
                    if(resultX.type == 'info') {
                        let auditInfo = resultX.data;
                        let auditorStaffId = row.auditorStaffId;
                        let auditorName = row.auditorName;
                        if(!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                            initPostId = auditInfo.postId;
                            auditorStaffId = auditInfo.staffId;
                            auditorName = auditInfo.staffName;
                        }
                        // 不走审批流程，选择岗位
                        showComActionPostSelectDlg({
                            rescUrl: Vue.$getClassInfo(self).path,
                            action: 'audit',
                            useParent: true,
                            expandedParents: true,
                            headComFlag: self.headComFlag,
                            initPostId: initPostId,
                            showAuditor: !Utils.isNoB(auditorStaffId),
                            showAuditStaff: true,
                            auditorStaffId: auditorStaffId,
                            auditorName: auditorName
                        }, function (resultData) {
                            resultData = resultData || {};
                            if(resultData.postId == null) {
                                Toast.show('请选择审核岗位', 3000, 'warning');
                                return false;
                            }
                            //
                            let postData = {
                                id: row.id,
                                auditorPostId: resultData.postId,
                                appliedComLevel: resultData.comLevel,
                                auditorStaffId: resultData.auditorStaffId,
                                auditorName: resultData.auditorName,
                                applyDesc: resultData.applyDesc,
                                // 仅在 outAuditFlag == true 时生效
                                needFutherAudit: self.needFutherAudit, // 外部独立审批过的请购单是否需要在系统内再次审批
                            };
                            //
                            let theLoad = MsgBox.loading();
                            devcReqrApi.applyDeviceRequireVoucher(postData, function (result) {
                                if(result.type == 'info') {
                                    self.getRequireVoucherList(self.scopeEntity.shopFlag ? 'Reported' : 'Applied');
                                } else {
                                    MsgBox.failure(result.message);
                                }
                                theLoad.hide();
                            });

                        }, this);
                    } else {
                        MsgBox.warning(resultX.message);
                    }
                });
            }
        },
        toAuditBpConf: function (row, auditorList, theDlg, departId, decisionBasisVal) {
            let self = this;
            let postData = {
                id: row.id,
                no: row.no,
                auditorList: Utils.merge([], auditorList),
                //
                dingdingFlag: row.dingDingFlag,
                feiShuFlag: row.feiShuFlag,
                decisionBasisVal: decisionBasisVal,
                bizScenario: row.bizScenario || null   // 业务类型
            };
            if(typeof departId === 'string') {
                postData.feiShuDepartId = departId || null
            } else {
                postData.departId = departId || null
            }
            let theLoad = MsgBox.loading();
            devcReqrApi.applyDeviceRequireVoucher(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    if(!Utils.isNoB(theDlg)) {
                        theDlg.close();
                    }
                    self.getRequireVoucherList(self.scopeEntity.shopFlag ? 'Reported' : 'Applied');
                    //
                    if(!self.needAssignAuditors) {
                        let auditBpStateInfo = result.data || {};
                        if(Utils.isTrue(auditBpStateInfo.outerAuditFlag) && !Utils.isTrue(auditBpStateInfo.bpStarted) && auditBpStateInfo.auditState == 0) {
                            let params = {
                                no: auditBpStateInfo.voucherNo
                            };
                            self.openOuterBpStartWin(params);
                        }
                    }
                    MsgBox.success('申请成功');
                } else {
                    MsgBox.failure(result.message);
                }
            });
        },
        goToNewPageForBatch: function () {
            this.goToNewPage(null, true);
        },
        goToNewPage: function (id, isBatchFalg) {
            if(!Utils.repeatChecker.isValidFor('goToNewPage', 1000)) {
                return;
            }
            let parentPath = '/device/require/voucher/list';
            this.$getRouter().push({
                path: SwbDeviceRequireVocherSave.path,
                query: {
                    id: id,
                    lowCostFlag: false,
                    parentPath: parentPath,
                    isBatchFalg: Utils.isTrue(isBatchFalg)
                }
            });
        },
        saveOrderById: function (id) {
            let self = this;
            self.$confirm('确定生成订单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {
                    id: id
                };
                let theLoad = MsgBox.loading();
                devcReqrApi.saveOrderById(postData, function (result) {
                    if(result.type == 'info') {
                        MsgBox.success('已生成订单');
                        self.checkStateValue = 'orderEnd';
                        self.getRequireVoucherList('orderEnd');
                    } else {
                        MsgBox.failure(result.message);
                    }
                    theLoad.hide();
                });
            });
        },
        showOrderById: function (id) {
            showRouteLayer({
                title: '商品订单',
                query: {
                    cgVoucherId: id,
                },
                template: SwbGoodsOrderList
            });
        },
        contractShowGoodsOrder: function (id) {
            showRouteLayer({
                title: '合同订单',
                query: {
                    cgVoucherId: id,
                },
                template: SwbContractGoodsOrderList
            });
        },
        saveOrderList: function () {
            if(!Utils.repeatChecker.isValidFor('saveOrderList', 1000)) {
                return;
            }
            let self = this;
            let selectList = this.getTableSelection() || [];
            if(selectList.length <= 0) {
                MsgBox.warning('请选择对应的请购单！');
                return;
            }
            for(let i = 0; i < selectList.length; i++) {
                let select = selectList[i];
                if(select.auditState != 1) {
                    let title = select.auditState == 0 ? '未审核' : '未审核通过';
                    MsgBox.warning('【' + select.no + '】' + title + '，不可生成订单');
                    return;
                }
                if(Utils.isTrue(select.goodsOrderGenFlag)) {
                    MsgBox.warning(select.no + '已生成订单');
                    return;
                }
            }
            let voucherIds = selectList.pluck('id') || [];
            requireGoodsItemStatisDlg({voucherIds: voucherIds, lowCostFlag: false}, function (resultDLg, theDlg) {
                theDlg.close();
                let theLoad = MsgBox.loading();
                devcReqrApi.saveRequireGoodsItemList(resultDLg, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let postData = {
                            ids: voucherIds
                        };
                        devcReqrApi.saveOrderBatch(postData, function (orderResult) {
                            if(orderResult.type == 'info') {
                                MsgBox.success('已生成订单');
                                self.checkStateValue = 'orderEnd';
                                self.getRequireVoucherList('orderEnd');
                            } else {
                                MsgBox.failure(orderResult.message);
                            }

                        });
                    } else {
                        MsgBox.failure(orderResult.message);
                    }
                })

            });
        },
        // 查看附件信息
        showFile: function (voucherId) {
            Vue.$showDialog({
                title: '查看附件',
                width: 1000,
                height: 800,
                okVisible: false,
                showCloseBtn: true,
                cancelText: '关闭',
                template: '<swb-device-require-voucher-file :voucherId = "voucherId" ref="swb_device_require_voucher_file"></swb-device-require-voucher-file>',
                data: {
                    voucherId: voucherId,
                },
                methods: {},
                okClicked: function () {
                    let result = this.$refs.swb_share_acc_adjust_apply_form_file.getDlgResult() || {};
                    //
                }
            });
        },
        // 导出
        doExport: function () {
            let self = this;
            let pageSize = getDefaultDownloadPageSize();
            let pages = Math.ceil(self.totalCount / pageSize);
            if(pages > 10) {
                showPageRangeSelDlg('选择导出文件序号', pages, 10, this.lastPageNumber, function (ok, range) {
                    if(ok) {
                        if(range.to == pages) {
                            self.lastPageNumber = 0;
                        } else {
                            self.lastPageNumber = range.to;
                        }
                        //
                        self.exportPrintData(pageSize, range.from, range.to);
                    }
                }, {pageSize: pageSize})
            } else {
                self.exportPrintData(pageSize);
            }
        },
        exportPrintData(pageSize, fromPages, toPages) {
            let totalCount = this.totalCount;
            let pages = Math.ceil(totalCount / pageSize);
            //
            fromPages = fromPages == null ? 1 : fromPages;
            toPages = toPages == null ? pages : toPages;
            let tableData = this.getTableData(pages, pageSize);
            //
            let url = getAppUrl('/file/export/as/excel');
            let downloadUrls = [];
            for(let i = fromPages; i <= toPages; i++) {
                let tmpFile = {};
                tmpFile.url = url;
                tmpFile.post = true;
                tmpFile.fileName = '资产请购单' + (pages == 1 ? '' : ('_' + (i)));
                tmpFile.seqNo = i;
                //
                let data = Utils.merge({}, tableData);
                data.pageNumber = i;
                data.fileName = tmpFile.fileName;
                tmpFile.data = data;
                downloadUrls.push(tmpFile);
            }
            let title = '资产请购单-下载| 每个文件' + pageSize + '条数据';
            showGrpDownloadDlg(title, downloadUrls);
        },
        getTableData(pages, pageSize) {
            let resultTable = this.$refs.result_table;
            let tableData = resultTable.getTableData(true);
            delete tableData.rows;//减少数据传输量
            //
            let rowsSrc = {};
            rowsSrc.data = this.getPostData();
            rowsSrc.url = '/devcReqr/device/require/voucher/list/get';
            tableData.rowsSrc = rowsSrc;
            //
            tableData.pageSize = pageSize;
            tableData.pageCount = this.totalCount;
            tableData.pages = pages;
            return tableData;
        },
        getPostData() {
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, this.exportFilter);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            let multipleSelection = this.getTableSelection();
            if(multipleSelection.length > 0) {
                let ids = [];
                multipleSelection.forEach(function (el) {
                    ids.push(el.id);
                });
                filterItems.ids = ids;
            }
            filterItems.exportFlag = true;
            //
            let postData = {};
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            return postData;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherManager.vue